<template>
  <div id="invoice_sector" class="sector invoice-sector">
    <div class="row">
      <div class="col-12 sector__header text-accent">
        {{ $t("invoices.title") }}
      </div>
      <div class="col-12 sector__content">
        <div class="row">
          <div class="col-12 py-0">
            <el-form-item prop="invoice_type" class="mb-0" required>
              <!-- 雲端發票 (需有載具) -->
              <template v-if="enableEInvoice">
                <el-radio-group v-show="false" v-model="form.invoice_print_mark" size="large"
                  :class="isMobile ? 'mb-1' : 'mb-3'" @change="handleDonation">
                  <el-radio-button label="N">
                    {{ $t("invoices.electronicPersonal") }}
                  </el-radio-button>
                  <el-radio-button label="Y">
                    <!-- {{ $t("invoices.requestPaper") }} -->
                    {{ $t("invoices.companyNumber") }}
                    ({{ $t("線上列印") }})
                  </el-radio-button>
                  <!-- <el-radio-button label="donate">
                    {{ $t("invoices.donation") }}
                  </el-radio-button> -->
                </el-radio-group>

                <!-- <template v-if="isMobile">
                  <el-radio-group
                    v-model="form.invoice_type"
                    size="large"
                    class="mb-3"
                  >
                    <el-radio-button label="donate">
                      {{ $t("invoices.donation") }}
                    </el-radio-button>
                  </el-radio-group>
                </template> -->
              </template>
              <template v-else>
                <!-- 二聯三聯紙本 (索取紙本) -->
                <el-radio-group v-model="form.invoice_type" size="large" class="mb-3">
                  <el-radio-button label="invoice">
                    {{ $t("invoices.personal") }}
                  </el-radio-button>
                  <el-radio-button label="invoice_paper">
                    {{ $t("invoices.company") }}
                  </el-radio-button>
                </el-radio-group>
              </template>
            </el-form-item>

            <!-- 電子發票 -->
            <div v-if="enableEInvoice">
              <!-- 發票類型 -->
              <div class="col-12 pb-0">
                <el-radio-group v-model="form.invoice_type" size="large" :class="isMobile ? 'mb-1' : 'mb-3'"
                  @change="handlePrintMark">
                  <el-radio-button label="invoice">
                    {{ $t("invoices.electronicPersonal") }}
                    <!-- {{ $t("invoices.eturnkey") }} -->
                  </el-radio-button>
                  <el-radio-button label="invoice_paper">
                    {{ $t("invoices.companyNumber") }}
                    ({{ $t("線上列印") }})
                  </el-radio-button>
                  <el-radio-button label="donate">
                    {{ $t("invoices.donation") }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>

            <!-- 個人雲端發票 -->
            <div v-if="form.invoice_print_mark == 'N'" class="row">
              <div v-if="form.invoice_type == 'invoice'" class="col-12 mb-2 pb-0">
                <el-radio-group v-model="form.invoice_relation_option" size="large" @change="onChangeRelation">
                  <el-radio-button label="ORDER">
                    {{ $t("invoices.member") }}
                  </el-radio-button>
                  <el-radio-button label="MOBILE">
                    {{ $t("invoices.mobile") }}
                  </el-radio-button>
                  <el-radio-button label="MOICA">
                    {{ $t("invoices.moica") }}
                  </el-radio-button>
                  <!-- <el-radio-button v-show="false" label="PAPER">
                    {{ $t("invoices.requestPaper") }}
                  </el-radio-button> -->
                </el-radio-group>
              </div>
              <!-- <el-radio-button label="invoice_paper"> {{ $t("invoices.companyNumber") }} </el-radio-button> -->
              <!-- 手機條碼 -->
              <div class="col-12 py-0" v-if="form.invoice_relation_option == 'MOBILE'">
                <el-form-item :label="$t('invoices.mobileCode')" prop="invoice_relation_value">
                  <el-input v-model="form.invoice_relation_value" :placeholder="$t('errors.pleaseInput', [
                    $t('invoices.mobileCode'),
                  ])" size="large" maxlength="50" />
                </el-form-item>
              </div>
              <!-- 自然人憑證 -->
              <div class="col-12 py-0" v-else-if="form.invoice_relation_option == 'MOICA'">
                <el-form-item :label="$t('invoices.moicaCode')" prop="invoice_relation_value">
                  <el-input v-model="form.invoice_relation_value" :placeholder="$t('errors.pleaseInput', [
                    $t('invoices.moicaCode'),
                  ])" size="large" maxlength="50" />
                </el-form-item>
              </div>

              <!-- 有載具情況下輸入公司統編（不須列印發票） -->
              <div v-show="false" v-if="form.invoice_type == 'invoice' && form.invoice_relation_option !== 'PAPER'"
                class="w-full text-right">
                <el-checkbox v-model="carrierVat">
                  {{ $t("invoices.companyNumber") }}
                  (不需提供發票證明聯)
                </el-checkbox>
              </div>

              <!-- 捐贈 -->
              <div class="w-full px-2" v-if="form.invoice_type == 'donate'">
                <el-form-item :label="$t('invoices.donateXCA')" label-width="0px" prop="invoice_donate_code" required>
                  <el-select v-model="form.invoice_donate_code" size="large" style="width: 100%" filterable>
                    <template v-if="einvoiceDonationOptions?.length">
                      <el-option v-for="item in einvoiceDonationOptions" :key="item.code" :label="item.name"
                        :value="item.code" />
                    </template>
                    <template v-else>
                      <el-option v-for="item in state.invoiceDonateOptions" :key="item.value" :label="item.label"
                        :value="item.value" />
                    </template>
                  </el-select>
                </el-form-item>
              </div>

              <!-- 電子發票證明聯 -->
              <div v-else class="col-12 mb-2 pb-0">
                <el-radio-group v-show="false" v-model="form.invoice_type" size="large" class="mb-3">
                  <el-radio-button label="invoice">
                    {{ $t("invoices.paperPersonal") }}
                  </el-radio-button>
                  <el-radio-button label="invoice_paper">
                    {{ $t("invoices.electronicCorporation") }}
                  </el-radio-button>
                </el-radio-group>
              </div>
            </div>
            <!-- 統編抬頭 -->
            <div class="row" v-if="form.invoice_type == 'invoice_paper' || carrierVat">
              <div class="col-12 text-accent text-sm sm:text-xs mb-2" v-if="enableEInvoice && !carrierVat">
                {{ $t("公司發票(報帳用線上列印)請至【訂單查詢→發票資訊】") }}
              </div>
              <div class="col-12 col-md-4 py-0">
                <el-form-item :label="$t('invoices.uniformNumbers')" prop="invoice_paper_no">
                  <el-input v-model="form.invoice_paper_no" :placeholder="$t('carts.required')" size="large"
                    maxlength="10" />
                </el-form-item>
              </div>

              <div class="col-12 col-md-4 py-0">
                <el-form-item :label="$t('invoices.companyName')" prop="invoice_paper_title">
                  <el-input v-model="form.invoice_paper_title" :placeholder="$t('carts.required')" size="large"
                    maxlength="100" />
                </el-form-item>
              </div>

              <div v-if="enableEInvoice && !carrierVat" class="col-12 col-md-4 py-0">
                <el-form-item :label="$t('invoices.mobileCode')" prop="invoice_paper_relation_mobile">
                  <el-input v-model="form.invoice_paper_relation_mobile" size="large" maxlength="8"
                    :placeholder="$t('carts.optional')" />
                </el-form-item>
              </div>
            </div>

            <!-- 紙本發票地址 -->
            <el-form-item class="mb-0 px-3" v-if="!sameHome && (showAddress || !enableEInvoice)" required
              :label="$t('invoices.address')">
              <el-row :gutter="10" style="width: 100%">
                <el-col :xs="24" :sm="12" :md="6" class="address-select mb-3">
                  <el-form-item prop="invoice_province">
                    <el-select v-model="form.invoice_province" :disabled="Object.keys(proviceMap).length <= 0"
                      :placeholder="`---${$t('users.province')}---`" size="large" style="width: 100%">
                      <el-option v-for="(obj, code) in proviceMap" :key="code" :label="obj.name + '(' + obj.name_en + ')'"
                        :value="code" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col v-if="!!Object.keys(invoiceCityMap).length" :xs="24" :sm="12" :md="6" class="address-select mb-3">
                  <el-form-item prop="invoice_city">
                    <el-select v-model="form.invoice_city" :disabled="Object.keys(invoiceCityMap).length <= 0"
                      :placeholder="`---${$t('users.city')}---`" size="large" style="width: 100%">
                      <el-option v-for="(obj, code) in invoiceCityMap" :key="code"
                        :label="obj.name + '(' + obj.name_en + ')'" :value="code" :disabled="isTwOuterIslands(code)" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col v-if="!!Object.keys(invoiceRegionMap).length" :xs="24" :sm="12" :md="6"
                  class="address-select mb-3">
                  <el-form-item prop="invoice_region">
                    <el-select v-model="form.invoice_region" :disabled="Object.keys(invoiceRegionMap).length <= 0"
                      :placeholder="`---${$t('users.region')}---`" size="large" style="width: 100%">
                      <el-option v-for="(obj, code) in invoiceRegionMap" :key="code"
                        :label="obj.name + '(' + obj.name_en + ')'" :value="code" />
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :xs="24" :sm="12" :md="6" class="address-select mb-3">
                  <el-form-item prop="invoice_postal_code">
                    <el-input v-model="form.invoice_postal_code" :placeholder="$t('users.postcode')" size="large"
                      maxlength="20" />
                  </el-form-item>
                </el-col>

                <el-col :span="24" class="address-select mb-3">
                  <el-form-item prop="invoice_address">
                    <el-input v-model="form.invoice_address" :placeholder="$t('errors.pleaseInput', [
                      $t('invoices.address'),
                    ])
                      " size="large" maxlength="100" show-word-limit />
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form-item>

            <div class="px-3 pt-1" v-if="hasHome && showAddress">
              <el-checkbox v-model="sameHome" @change="handleSameHome">
                {{ $t("carts.sameAsBuyer") }}
              </el-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { watch, ref, computed } from "vue";
import { useVModel } from "@vueuse/core";
import { breakpoint } from "../../../utils";
import Papa from 'papaparse';

const props = defineProps({
  modelValue: Object,
  state: Object,
  proviceMap: Object,
  usedLogisticTypes: Array,
  enableEInvoice: {
    type: Boolean,
    default: false,
  },
});
const emit = defineEmits(["update:modelValue", "change"]);

const form = useVModel(props, "modelValue", emit);

const einvoiceDonationOptions = ref([]);

const isMobile = computed(() => breakpoint.value.xs || breakpoint.value.sm)

// 預設會員之前填過的 (目前先放空)
const loginUserMetadata = computed(() => ({}));

const fetchEInvoiceDonationOptions = async () => {
  if (einvoiceDonationOptions.value.length > 0) {
    return;
  }
  try {
    const response = await fetch('/static/csv/xca.csv');
    const csvText = await response.text();
    Papa.parse(csvText, {
      header: true,
      complete: (results) => {
        einvoiceDonationOptions.value = results.data
          .map((row) => {
            let code = row['捐贈碼'];
            // let name = row['受捐贈機關或團體名稱'];
            let name = row['受捐贈機關或團體簡稱'];
            if (!code || !name) {
              return {};
            }
            code = code.match(/[0-9]+/g)[0];
            name = `(${code}) ${name}`;
            return {
              name,
              code,
            };
          })
          .filter((i) => i.code);
      },
    });
  } catch (error) {
    console.error('Error fetching or parsing CSV:', error);
    // Handle error, maybe show a message to the user
  }
};

// 啟用電子發票
if (props.enableEInvoice) {
  const {
    relation_option,
    relation_mobile,
    relation_moica,
    donate,
    donate_code,
  } = loginUserMetadata.value.einvoice || {};
  if (relation_option === "MOBILE") {
    form.value.invoice_type = "invoice";
    form.value.invoice_relation_option = "MOBILE";
    form.value.invoice_relation_value = relation_mobile;
  } else if (relation_option === "MOICA") {
    form.value.invoice_type = "invoice";
    form.value.invoice_relation_option = "MOICA";
    form.value.invoice_relation_value = relation_moica;
  } else {
    form.value.invoice_relation_option = "ORDER";
  }
  if (donate) {
    fetchEInvoiceDonationOptions().finally(() => {
      form.value.invoice_type = "donate";
      form.value.invoice_donate_code = donate_code;
    });
  }
}

const isDev = computed(() => {
  const { serverNode } = process.env;
  if (serverNode.includes("PROD_")) {
    return false;
  }
  return true;
});

const handlePrintMark = (val) => {
  // console.debug("handlePrintMark", val)
  if (val == "invoice_paper") {
    form.value.invoice_print_mark = "Y";
    carrierVat.value = false
  } else {
    form.value.invoice_print_mark = "N";
  }
  if (val == "donate") {
    carrierVat.value = false
    form.value.invoice_relation_option = "ORDER";
  }
};

const onChangeRelation = (val) => {
  // console.debug("onChangeRelation: ", val)
  if (val == 'PAPER') {
    carrierVat.value = false
  }
};

const handleDonation = (val) => {
  console.debug("捐贈發票", val)
  if (val == "donate") {
    form.value.invoice_relation_option = "ORDER";
    form.value.invoice_type = "donate";
  }
  console.debug("invoice_relation_option", form.value.invoice_relation_option)
  console.debug("invoice_type", form.value.invoice_type)
}

// 與宅配地址相同
const sameHome = ref(true);

const carrierVat = ref(false);

const twOuterIslands = [
  "ILA.DYI",
  "KHH.DSA",
  "KHH.NSA",
  "PEN.MGG",
  "PEN.WAN",
  "PEN.QMI",
  "PEN.BSA",
  "PEN.HXI",
  "PEN.XYU",
  "KMN.LYU",
  "KMN.WQU",
  "KMN.JCG",
  "KMN.JHU",
  "KMN.JNG",
  "KMN.JSA",
  "TTT.LDO",
  "TTT.LYU",
  "PIF.LQU",
  "LCG.BGN",
  "LCG.DYN",
  "LCG.JGG",
  "LCG.NGN",
];

const isTwOuterIslands = (city) => {
  // if (form.value.country != 'TW') {
  //   return false
  // }
  // const k = form.value.invoice_province + "." + city
  // if (twOuterIslands.includes(k)) {
  //   return true
  // }
  return false;
};

const hasHome = computed(() => {
  const delivery_types = ["HOME"];
  const target = props.usedLogisticTypes.find((t) => {
    return delivery_types.includes(t);
  });
  return !!target;
});

const showAddress = computed(() => {
  // enableEInvoice
  return !props.enableEInvoice && form.value.invoice_print_mark == "Y";
  if (
    props.enableEInvoice &&
    (form.value.invoice_type == "invoice" ||
      form.value.invoice_type == "invoice_paper_relation")
  ) {
    return false;
  } else if (form.value.invoice_type == "donate") {
    return false;
  }
  return true;
});
const invoiceCityMap = computed(() => {
  if (form.value.invoice_province) {
    const province_info = props.proviceMap[form.value.invoice_province];
    const postal_code = province_info.postal;
    form.value.invoice_city = null;
    form.value.invoice_postal_code = postal_code ? postal_code : null;
    return province_info.city || {};
  }
  return {};
});

const invoiceRegionMap = computed(() => {
  if (form.value.invoice_city) {
    const city_info = invoiceCityMap.value[form.value.invoice_city];
    const postal_code = city_info.postal;
    if (postal_code) {
      form.value.invoice_postal_code = postal_code;
    }
    return city_info.region || {};
  }
  return {};
});

const handleSameHome = (val) => {
  emit("change", val);
  form.value.invoice_postal_code = form.value.postal_code;
  form.value.invoice_province = form.value.province;
  form.value.invoice_region = form.value.region;
  form.value.invoice_city = form.value.city;
  form.value.invoice_address = form.value.address;
};

watch(
  () => hasHome.value,
  (val) => {
    if (!val) {
      sameHome.value = val;
      handleSameHome(sameHome.value);
    }
  },
  { deep: false, immediate: true }
);

const invoicePrintMark = computed(() => form.value?.invoice_print_mark);

watch(
  () => invoicePrintMark.value,
  (val) => {
    // 列印紙本
    if (val == "Y") {
      form.value.invoice_type = "invoice_paper";
      form.value.invoice_relation_option = "MOBILE";
    }
  },
  { deep: true, immediate: true }
);

const invoiceRelationOption = computed(
  () => form.value?.invoice_relation_option
);

watch(
  () => invoiceRelationOption.value,
  (val) => {
    if (val === "MOBILE") {
      const { relation_mobile } = loginUserMetadata.value.einvoice || {};
      if (relation_mobile) {
        form.value.invoice_relation_value = relation_mobile;
      }
    } else if (val === "MOICA") {
      const { relation_moica } = loginUserMetadata.value.einvoice || {};
      if (relation_moica) {
        form.value.invoice_relation_value = relation_moica;
      }
    }
  },
  { deep: false, immediate: false }
);
</script>
<style lang="scss">
.invoice-sector {
  .el-form-item {
    margin-bottom: 6px;

    label {
      margin: 0;
      padding: 0;
    }
  }

  .el-radio-button__inner {
    padding: 12px !important;
  }
}
</style>